<div class="textarea-wrapper">
    <div class="backdrop" [innerHTML]="highlightedText"></div>
    <div class="click-overlay" [innerHTML]="clickableText"></div>
    <textarea gaAutocomplete [autocompleteOptions]="['hello', 'symbol']"></textarea>
</div>
